import {setNavigation} from '../../../store/actions/fuse'
import {generateUserMenu} from '../../../utils'

export const SET_USER_DATA = '[USER] SET DATA'
export const SET_USER_PROJECT = '[USER] SET PROJECT'
export const SET_USER_SELECTED_PROJECT = '[USER] SELECT PROJECT'

export function selectProject(project) {
  return dispatch => {
    dispatch(setNavigation(generateUserMenu(project)))
    dispatch({
      type: SET_USER_SELECTED_PROJECT,
      payload: project,
    })
  }
}

export function updateUserSettings(settings) {}

export function updateUserShortcuts(shortcuts) {}



// WEBPACK FOOTER //
// ./src/auth/store/actions/user.actions.js